import {
  type CrowdexResolvedAgent,
  type CrowdexSavedAgent,
  canonicalAcpAgentId,
} from '@crowdex/agent-contracts';
import type { NativeAgent } from '@/lib/native-desktop';
import { acpAgentPreferenceId } from './acp-agent-catalog';

export type AgentCapabilityMode = 'inherit' | 'custom' | 'none';

export function resolvedAgentCapabilityMode(profile: CrowdexSavedAgent): AgentCapabilityMode {
  return profile.capabilityMode ?? 'inherit';
}

export function resolvedAgentModelId(
  profile: CrowdexSavedAgent | null | undefined,
  inheritedModelId: string,
): string {
  if (!profile || profile.modelMode === 'inherit') return inheritedModelId;
  return profile.modelId ?? inheritedModelId;
}

export function savedAgentParticipant(
  profile: CrowdexSavedAgent,
  agents: readonly NativeAgent[],
  id: string,
): CrowdexResolvedAgent | null {
  const runtime = agents.find(
    (agent) =>
      canonicalAcpAgentId(acpAgentPreferenceId(agent)) === canonicalAcpAgentId(profile.agentId),
  );
  if (!runtime || !profile.name.trim()) return null;
  return {
    id,
    profileId: profile.id,
    ...(profile.animatedAvatarId ? { animatedAvatarId: profile.animatedAvatarId } : {}),
    ...(profile.avatar ? { avatar: profile.avatar } : {}),
    ...(profile.mcpServerNames ? { mcpServerNames: profile.mcpServerNames } : {}),
    ...(profile.skillRefs ? { skillRefs: profile.skillRefs } : {}),
    ...(profile.capabilityMode === undefined ? {} : { capabilityMode: profile.capabilityMode }),
    ...(profile.description === undefined ? {} : { description: profile.description }),
    ...(profile.policy === undefined ? {} : { policy: profile.policy }),
    ...(profile.systemReminders === undefined ? {} : { systemReminders: profile.systemReminders }),
    ...(profile.collaboration === undefined ? {} : { collaboration: profile.collaboration }),
    name: profile.name.trim(),
    agentId: runtime.id,
    ...(profile.modelMode === undefined ? {} : { modelMode: profile.modelMode }),
    ...(profile.modelId ? { modelId: profile.modelId } : {}),
    ...(profile.instructions ? { instructions: profile.instructions } : {}),
  };
}
